// Values must match the backend Xmedical.Domain.AppointmentNotifications
// .AppointmentNotificationStatus enum exactly — they are persisted ints sent
// over the wire. (Sending=2 / Sent=3 were previously off-by-one here, which
// rendered a successfully-sent SMS as "Failed".)
export enum AppointmentNotificationStatus {
  Pending = 0,
  Scheduled = 1,
  Sending = 2,
  Sent = 3,
  Failed = 4,
  Cancelled = 5,
  Unknown = -1
}

export const AppointmentNotificationStatusLabels: Record<AppointmentNotificationStatus, string> = {
  [AppointmentNotificationStatus.Pending]: 'Pending',
  [AppointmentNotificationStatus.Scheduled]: 'Scheduled',
  [AppointmentNotificationStatus.Sending]: 'Sending',
  [AppointmentNotificationStatus.Sent]: 'Sent',
  [AppointmentNotificationStatus.Failed]: 'Failed',
  [AppointmentNotificationStatus.Cancelled]: 'Cancelled',
  [AppointmentNotificationStatus.Unknown]: 'Unknown'
};
